var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';
import { formatText } from 'bernie-l10n';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLink } from 'uitk-react-link';
import { UitkPillContainer, UitkRemovablePill } from 'uitk-react-pill';
import { UitkSpacing } from 'uitk-react-spacing';
import { LinkTracked } from '../../../utils/click-trackers';
import { useStores } from '../../../utils/hooks';
import { getPageId } from '../../../helpers/common-helper';
import { handlePillsClick } from '../../../helpers/activity-search-helper';
export var FilterPills = function (_a) {
  var filters = _a.filters,
    clearLabel = _a.clearLabel,
    clearAnalytics = _a.clearAnalytics,
    clearURL = _a.clearURL;
  var _b = useStores(),
    activitySearchStore = _b.activitySearchStore,
    analytics = _b.analytics,
    searchCriteriaStore = _b.searchCriteriaStore;
  var history = useHistory();
  var location = useLocation();
  var pageId = getPageId(activitySearchStore);
  if (!(filters === null || filters === void 0 ? void 0 : filters.length)) {
    return null;
  }
  var pillRefs = __spreadArray([], __read(new Array(filters.length)), false).map(function () {
    return React.createRef();
  });
  React.useEffect(function () {
    var _a, _b, _c;
    if (searchCriteriaStore.pillRemoveIndex !== null) {
      if (pillRefs.length > 0) {
        if (searchCriteriaStore.pillRemoveIndex === 0) {
          (_a = pillRefs[0].current) === null || _a === void 0 ? void 0 : _a.focus();
        } else {
          (_c = (_b = pillRefs[searchCriteriaStore.pillRemoveIndex - 1]) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.focus();
        }
      }
    }
  });
  var Pills = function (_a) {
    var pillRefs = _a.pillRefs;
    return React.createElement(React.Fragment, null, filters.map(function (filter, index) {
      return React.createElement(UitkLayoutFlexItem, {
        key: "pill-".concat(index)
      }, React.createElement("div", {
        "data-testid": "filter-pill"
      }, React.createElement(UitkRemovablePill, {
        id: "pill-".concat(index),
        disabled: false,
        buttonRef: pillRefs[index],
        onClick: function () {
          var _a;
          return handlePillsClick(history, location, ((_a = filter === null || filter === void 0 ? void 0 : filter.nextSearchCriteria) === null || _a === void 0 ? void 0 : _a.selections) || [], pageId, analytics, activitySearchStore, searchCriteriaStore, index, filters);
        },
        altText: filter.pill.accessibility || formatText('lx.pills.remove.accessibility.text', filter.pill.primary)
      }, React.createElement("span", {
        "aria-hidden": "true"
      }, filter.pill.primary))));
    }));
  };
  var onRemoveAllFiltersClick = function () {
    activitySearchStore.searchSetup();
    searchCriteriaStore.pillRemoveIndex = -1;
  };
  var ClearAllPill = function () {
    return clearLabel ? React.createElement(UitkLayoutFlexItem, {
      alignSelf: "center"
    }, React.createElement("div", {
      "data-testid": "filter-remove-pill"
    }, React.createElement(UitkLink, {
      inline: true,
      noWrap: true
    }, React.createElement("button", {
      type: "button"
    }, React.createElement(LinkTracked, {
      rfrr: (clearAnalytics === null || clearAnalytics === void 0 ? void 0 : clearAnalytics.referrerId) || '',
      linkName: (clearAnalytics === null || clearAnalytics === void 0 ? void 0 : clearAnalytics.linkName) || '',
      to: clearURL,
      onClick: onRemoveAllFiltersClick
    }, clearLabel))))) : React.createElement(React.Fragment, null);
  };
  return React.createElement(Viewport, null, React.createElement(ViewSmall, null, React.createElement(UitkPillContainer, null, React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'three',
      blockend: 'one'
    }
  }, React.createElement(UitkLayoutFlex, {
    className: "uitk-scroll-horizontal",
    space: "two"
  }, React.createElement(Pills, {
    pillRefs: pillRefs
  }), React.createElement(ClearAllPill, null))))), React.createElement(ViewLarge, null, React.createElement(UitkSpacing, {
    margin: {
      block: 'three'
    }
  }, React.createElement(UitkLayoutFlex, {
    space: "two",
    wrap: "wrap"
  }, React.createElement(Pills, {
    pillRefs: pillRefs
  }), React.createElement(ClearAllPill, null)))));
};